<!--
 * @Description: 批量下载支付详情
                 orderPeopleInfoBatchDownload接口中type参数根据childActiveIndex设置
 * @Date: 2022-06-10 20:35:04
-->
<template>
  <div style="text-align:center;">
    <div>
      <el-radio
        style="display:block;margin-right:0px;margin-bottom:20px;"
        v-model="radio"
        label="1"
      >
        汇总一个表格
      </el-radio>
      <el-radio style="display:block" v-model="radio" label="2">
        汇总多个表格
      </el-radio>
    </div>
    <div class="footer" style="margin-top:20px">
      <el-button @click="close">取消</el-button>
      <el-button @click="down" type="primary">确认</el-button>
    </div>
  </div>
</template>

<script>
import { csoCustomerOrder } from '@/api/ajax';

export default {
  name: '',
  props: {
    selectArr: {
      type: Array,
      default: () => []
    },
    childActiveIndex: {
      type: Number,
      default: 0
    },
    payPassagewayCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      radio: '1'
    };
  },
  methods: {
    close() {
      this.$xrkDialog.remove();
    },
    async down() {
      if (this.selectArr.length > 4000) {
        this.$message('最大支持下载4000条订单数据');
      } else {
        const selectArr = this.selectArr.map(item => {
          return {
            ...item,
            projectId: item.downLoadSign.split('_')[1] || null
          };
        });
        const param = JSON.stringify({
          type: this.childActiveIndex == 0 ? 2 : 1, // 1:批次 2:项目
          downLoadType: this.radio,
          requestOrderInfos: selectArr,
          payPassagewayCode: this.payPassagewayCode
        });
        this.$downloadFile(
          `${csoCustomerOrder.orderPeopleInfoBatchDownload}`,
          true,
          '',
          'post',
          'application/json',
          param
        );
        this.$xrkDialog.remove();
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
